"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListSellWithoutPwdRequest = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsTransfer_1 = require("../../model/hsTransfer");
var service_1 = require("../../../library/base/service");
var ListSellWithoutPwdRequest = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ListSellWithoutPwdRequest, _super);
    function ListSellWithoutPwdRequest() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '产品挂单(转让)接口';
        _this.code = '105013';
        _this.desc = '产品挂单(转让)接口';
        _this.requestParams = new hsTransfer_1.ListSellWithoutPwdRequestRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ListSellWithoutPwdRequest;
}(service_1.BaseService));
exports.ListSellWithoutPwdRequest = ListSellWithoutPwdRequest;
//# sourceMappingURL=listSellWithoutPwdRequest.js.map